import { IResponse } from "models";

export enum ActionType {
  STRESS_DEPARTMENT_LIST = "action/STRESS_DEPARTMENT_LIST",
  STRESS_DEPARTMENT_LIST_SUCCESS = "action/STRESS_DEPARTMENT_LIST_SUCCESS",
  STRESS_DEPARTMENT_LIST_ERROR = "action/STRESS_DEPARTMENT_LIST_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDepartmentListResponse extends IResponse {
  result: any;
}
